'use client';

import type React from 'react';
import { useEffect } from 'react';
import { useGTM } from '../model/hooks/useGTM';
import { GTMParamsManager } from '../model/manager';
import type { PageType } from '../model/enums';
interface Props {
  params?: Record<string, string | number | boolean>;
  pageType: PageType;
}
const setGA4UserId = (userId?: string) => {
  if (typeof window !== 'undefined' && window.dataLayer && userId) {
    window.dataLayer.push({
      user_id: userId
    });
  }
};
export const updateUserIdAfterBooking = (phoneNumber: string) => {
  const cleanedPhoneNumber = phoneNumber.replace(/[\s()+]/g, '');
  const newUserId = `idoctor_sha_${cleanedPhoneNumber}`;
  setGA4UserId(newUserId);
  return newUserId;
};
export const GTMInitializer: React.FC<Props> = ({
  params = {},
  pageType
}) => {
  const {
    trackEvent
  } = useGTM(pageType);
  useEffect(() => {
    const gtm = GTMParamsManager.getInstance();
    if (Object.keys(params).length > 0) {
      gtm.addParams(pageType, params);
    }
    trackEvent('page_view');
    return () => {
      const gtm = GTMParamsManager.getInstance();
      gtm.delParams(pageType);
    };
  }, [pageType, params, trackEvent]);
  return <></>;
};